import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import { MainMenu, UserAuth, Usuario } from '../../core/config/data.types';


export interface MenuContentProps {
  listItens:MainMenu[]
  funcLogado:{
    conta:UserAuth,
    usuario:Usuario
  }
  logout:()=>any,
  versao:string
}

export default function MenuContent(props:MenuContentProps) {
  const [indexAtual,setIndexAtual] = React.useState(-1);
  const { listItens } = props;
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List>
        {listItens.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton selected={index === indexAtual } onClick={()=>{item.eventOnClick();setIndexAtual(index)}}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
